/**
 * Fluent-Designs aus der Krannich-Rampe.
 *
 * Die Werte selbst stehen in brand.ts; hier wird nur daraus gebaut. Diese
 * Trennung haelt die Farbwerte frei von einem Laufzeitimport der
 * Komponentenbibliothek.
 */
import { createDarkTheme, createLightTheme, type Theme } from '@fluentui/react-components';
import { krannichBrand } from './brand.js';

export const krannichLightTheme: Theme = createLightTheme(krannichBrand);
export const krannichDarkTheme: Theme = createDarkTheme(krannichBrand);

// Im dunklen Design zieht Fluent die Linkfarbe eine Stufe zu dunkel; die
// Korrektur entspricht der Empfehlung aus der Fluent-Dokumentation.
krannichDarkTheme.colorBrandForegroundLink = krannichBrand[120];
krannichDarkTheme.colorBrandForegroundLinkHover = krannichBrand[130];

export { KRANNICH_BLACK, KRANNICH_YELLOW, krannichBrand } from './brand.js';
